module.exports = __webpack_public_path__ + "static/img/R1700BT.55293b75.jpg";